import springApi from '../../services/springApi'

export const getPromos = params => (
	new Promise((resolve, reject) => {
		springApi()
			.get('/promos', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storePromo = data => (
	new Promise((resolve, reject) => {
		springApi()
			.post('/promos', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const updatePromo = (id, data) => (
	new Promise((resolve, reject) => {
		springApi()
			.put(`/promos/${id}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const deletePromo = id => (
	new Promise((resolve, reject) => {
		springApi()
			.delete(`/promos/${id}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)